<template>
	<ValidationObserver tag="form" ref="observer" @submit.prevent="handleSubmit()">
	    <p class="f-14 f-m-12 margin-0"><strong>Info Rute dan Harga</strong></p>
	    <div class="col-6 margin-0">
			<div class="form-group mb-0">
				<label class="form-label">Kota asal</label>
				<ValidationProvider name="kota asal" rules="required" v-slot="{ errors }">
					<SelectOption keyId="origin_city" :defaultId="model.origin_city" @setValue="setValueOriginCity" :isDisabled="$route.params.id ? true : false" :class="{ 'error': errors[0] }"/>
					<input type="hidden" v-model="model.origin_city">
					<small style="color: red !important;" v-if="errors[0]">{{ errors[0] }}</small>
				</ValidationProvider>
			</div>
			<div class="form-group mb-0">
				<label class="form-label">Kota tujuan</label>
				<ValidationProvider name="Kota tujuan" rules="required" v-slot="{ errors }">
					<SelectOption keyId="destination_city" :defaultId="model.destination_city" @setValue="setValueDestinationCity" :isDisabled="$route.params.id ? true : false" :class="{ 'error': errors[0] }"/>
					<input type="hidden" v-model="model.destination_city">
					<small style="color: red !important;" v-if="errors[0]">{{ errors[0] }}</small>
				</ValidationProvider>  
			</div>  
	    </div>
	    <hr>
	    <div class="col-6 margin-0">
			<div class="form-group mb-0">
				<label class="form-label">Harga / Kg</label>
				<ValidationProvider name="Harga / Kg" rules="required|numeric|min_value:1" v-slot="{ errors }">		        
					<vue-numeric class="form-control" :class="{ 'error': errors[0] }" currency="Rp" separator="." label="harga" name="harga" v-model="model.price" placeholder="Masukkan harga / kg"></vue-numeric>
					<small style="color: red !important;" v-if="errors[0]">{{ errors[0] }}</small>
				</ValidationProvider>
			</div>
			<div class="form-group mb-0">
				<label class="form-label">Harga / Box</label>
				<ValidationProvider name="Harga / Box" rules="required|numeric|min_value:1" v-slot="{ errors }">		        
					<vue-numeric class="form-control" :class="{ 'error': errors[0] }" currency="Rp" separator="." label="harga" name="harga" v-model="model.price_box" placeholder="Masukkan harga / box"></vue-numeric>
					<small style="color: red !important;" v-if="errors[0]">{{ errors[0] }}</small>
				</ValidationProvider>
			</div>
	    </div> 
	    <hr>

	    <button type="submit" class="float-right btn btn-primary col-2 mb-3 w-m-1-2 margin-5 pd-10-20">Simpan</button>
	</ValidationObserver>
</template>

<script>
import SelectOption from './SelectOption'
export default {
	name: 'Form',
	components: {
		SelectOption
	},
	data() {
		return {
			model: {
				origin_city: null,
				destination_city: null,
				price: null,
				price_box: null,
				id_user: 1
			}
		}
	},
	beforeMount() {
		let _ = this

		if ( _.$route.params.id ) {
			_.getData()
		}
	},
	methods: {
		create() {
			let _ = this
			let data = _.model
			_.axios.post('pricelist', data )
				.then(resp => {
					if ( resp.data.status ) {
						_.$router.push({
							name: 'PriceIndex',
							params: {
								status: 'insert'
							}
						})
					}
				})
				.catch(err => {
					this.$toast.open({
						message: err.response.data.message,
						type: "error"
					})
				})
		},
		update() {
			let _ = this
			let update = {
				id: _.$route.params.id,
				..._.model
			}

			_.axios.patch('/pricelist', update)
				.then(resp => {
					if ( resp.data.status ) {
						_.$router.push({
							name: 'PriceIndex',
							params: {
								status: 'update'
							}
						})
					}
				})
				.catch(err => {
					this.$toast.open({
						message: err.response.data.message,
						type: "error"
					})
				})
		},
		getData() {
			let _ = this
			_.axios.get('/pricelist?id=' + _.$route.params.id)
				.then(resp => {
					let getData = resp.data.data.rows
					_.model = {
						origin_city: getData.origin_city,
						destination_city: getData.destination_city,
						price: getData.price,
						price_box: getData.price_box,
						id_user: 1
					}
				})
				.catch(err => {
					this.$toast.open({
						message: err.response.data.message,
						type: "error"
					})
				})
		},
		setValueOriginCity(val) {
			let _ = this
			_.model.origin_city = val
		},
		setValueDestinationCity(val) {
			let _ = this
			_.model.destination_city = val
		},
		async handleSubmit(){
			let _ = this
			const isValid = await this.$refs.observer.validate()
			if (isValid) {
				if (_.$route.params.id){
					_.update()
				} else {
					_.create()
				}
			}
		}
	}
}
</script>